import {NgModule} from '@angular/core';
import {Routes, RouterModule, PreloadAllModules} from '@angular/router';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FullComponent} from './layouts/full/full.component';
import {BlankComponent} from './layouts/blank/blank.component';
import {RouterGuardService} from "./shared-component/guard/router-guard/router-guard.service";
import {GuardGuard} from './shared-component/guard/auth/guard.guard';

export const routes: Routes = [
  {
    path: '',
    component: FullComponent,
    canActivate: [RouterGuardService],
    children: [
      { path: '', 
        redirectTo: '/dashboard', pathMatch: 'full'},
      { path: 'dashboard', 
        loadChildren: './dashboard/dashboard.module#DashboardModule'},
      { path: 'loanApplication', 
        loadChildren: './loanApplication/loanApplication.module#LoanApplicationModule'},
      { path: 'loans', 
        loadChildren: './loans/loans.module#LoansModule'},
      { path: 'application', 
        loadChildren: './application/application.module#ApplicationModule'},
      { path: 'lead', 
        loadChildren: './leads/leads.module#LeadsModule'},
      { path: 'partnerbranch', 
        loadChildren: './partnerbranches/partnerbranch.module#PartnerBranchModule'},
      { path: 'error', 
        loadChildren: './error/error.module#ErrorModule'},
    ]
  },
  {
    path: '',
    component: BlankComponent,
    canActivate: [GuardGuard],
    children: [
      {path: '', redirectTo: '/authentication', pathMatch: 'full'},
      {path: 'authentication', loadChildren: './authentication/authentication.module#AuthenticationModule'},
      {path: 'auth', loadChildren: './auth/auth.module#AuthModule'},
    ]
  },
  {
    path: '**',
    redirectTo: 'error'
  }];

@NgModule({
  imports: [RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules}), NgbModule.forRoot()],
  exports: [RouterModule]
})
export class AppRoutingModule {
}

